import { applyMiddleware, createStore, combineReducers } from 'redux';
import { composeWithDevTools } from '@redux-devtools/extension';

import thunk from 'redux-thunk';

import session from './reducers/session';
import reservations from './reducers/reservations';
import tourOperation from './reservationsTTOO/reducers/tourOperation';

import urls from './conf/urls';

const middlewareEnhancer = applyMiddleware(thunk);
const composedEnhancers = composeWithDevTools(middlewareEnhancer);

const getReducers = (section) => {
  switch (section) {
    case urls.TTOO: {
      const reducers = combineReducers({
        session: session,
        tourOperation: tourOperation,
        reservations: reservations
      });
      return reducers;
    }
    case urls.Groups: {
      const reducers = combineReducers({
        session: session
      });
      return reducers;
    }
    default:
      const reducers = combineReducers({
        session: session,
        tourOperation: tourOperation,
        reservations: reservations
      });
      return reducers;
  }
}

const getStore = (reducers) => createStore(reducers, composedEnhancers);

export { getStore, getReducers };
